import { render, staticRenderFns } from "./HowToUseDesktop.vue?vue&type=template&id=b765a792&"
import script from "./HowToUseDesktop.vue?vue&type=script&lang=js&"
export * from "./HowToUseDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HowToUseDesktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
